import { crv, cva } from '@/styled-system/css';

export const paginationReadoutRecipe = cva({
  variants: {
    ...crv('showNumberButtons', {
      false: {
        display: 'block',
      },
      true: {
        display: 'none',
      },
    }),
  },
});
